var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 58,
    viewBox: "0 0 92 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_124_284)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 84,
    height: 49.6901,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 83,
    height: 48.6901,
    rx: 9.5,
    stroke: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9153 21.7109H58.7479V21.6508H45.7042V27.4479H53.8949C52.7 30.8226 49.4891 33.2451 45.7042 33.2451C40.902 33.2451 37.0084 29.3516 37.0084 24.5493C37.0084 19.7471 40.902 15.8536 45.7042 15.8536C47.9209 15.8536 49.9376 16.6898 51.4731 18.0558L55.5725 13.9564C52.984 11.5441 49.5217 10.0564 45.7042 10.0564C37.7005 10.0564 31.2112 16.5456 31.2112 24.5493C31.2112 32.5531 37.7005 39.0423 45.7042 39.0423C53.708 39.0423 60.1972 32.5531 60.1972 24.5493C60.1972 23.5776 60.0972 22.629 59.9153 21.7109Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8821 17.8036L37.6437 21.2957C38.9322 18.1058 42.0525 15.8536 45.704 15.8536C47.9207 15.8536 49.9374 16.6898 51.4729 18.0558L55.5722 13.9564C52.9838 11.5441 49.5214 10.0564 45.704 10.0564C40.1372 10.0564 35.3096 13.1992 32.8821 17.8036Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7045 39.042C49.448 39.042 52.8495 37.6094 55.4213 35.2797L50.9357 31.484C49.4318 32.6277 47.594 33.2464 45.7045 33.2449C41.9349 33.2449 38.7341 30.8412 37.5283 27.4868L32.8022 31.1282C35.2007 35.8217 40.0718 39.042 45.7045 39.042Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9153 21.711H58.7479V21.6509H45.7042V27.4481H53.8949C53.3233 29.0542 52.2937 30.4576 50.9333 31.4851L50.9354 31.4836L55.421 35.2793C55.1036 35.5677 60.1972 31.7959 60.1972 24.5495C60.1972 23.5777 60.0972 22.6292 59.9153 21.711Z",
    fill: "#1976D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_124_284",
    x: 0,
    y: 0,
    width: 92,
    height: 57.6902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_124_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_124_284",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.32f7b9cd226b9183ad0658a840b16752.svg";
export { ForwardRef as ReactComponent };